import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { process as kendoProcess } from '@progress/kendo-data-query';
import { isNaN } from 'lodash';
import moment from 'moment';
import { array, object } from 'prop-types';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import TotalsPanel from '../../../components/TotalsPanel';
import BobActionMenu from '../../../components/BobActionMenu';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import DeleteAnnouncementModal from './DeleteAnnouncementModal';
import AnnouncementModal from '../../Dashboard/Announcements/AnnouncementModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';

import classes from './Table.module.css';
import aclasses from './AnnouncementsPage.module.css';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

const AnnouncementsList = ({
    bobLoading,
    fetchAnnouncementsList,
    deleteAnnouncements,
    history,
    announcements,
    deleteAnnouncement,
    announcementCreate,
    setAnnouncementCreate,
    updateAnnouncement,
    setSelectedAnnouncement,
    selectedAnnouncement,
    currentUser,
    setWorkBookMode,
    workbookModeEnabled,
    ...props
}) => {

    const initialDataState = {
        take: 10,
        skip: 0
    };

    const [announcementList, setAnnouncementList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageable] = useState({ pageSizes: true });
    const [deleteModal, setDeleteModal] = useState(false);
    const [currentAnnouncement, setCurrentAnnouncement] = useState(null);
    const [showMsg, setShowMsg] = useState(false);
    const [gridDataState, setGridDataState] = useState(initialDataState);
    const [titleColumnIndex, setTitleColumnIndex] = useState(1);

    useEffect(() => {
        if (!workbookModeEnabled) {
            setGridDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSearchTerm();
    }, []);

    useEffect(() => {
        const init = async () => {
            let admin = currentUser.isSuperUser;
            await fetchAnnouncementsList(admin);
        };
        if (currentUser.isSuperUser) init();
    }, [currentUser.isSuperUser]);

    const getAnnouncementList = () => {
        const init = async () => {
            let admin = currentUser.isSuperUser;
            await fetchAnnouncementsList(admin);
        };
        init();
    };

    const handleClickAction = (actionType) => {
        switch (actionType) {
            case 'active':
                break;
            case 'inactive':
                break;
            case 'delete':
                handleAnnouncementDelete(null);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (currentUser.isSuperUser) {
            setAnnouncementList(announcements);
        }
        else {
            if (announcements && announcements.length>0) {
                let lst = [];
                announcements.forEach(c=>{
                    if (c.status !== 'Draft') {
                        lst.push(c);
                    }
                });
                setAnnouncementList(lst);
            }
        }
    }, [announcements]);

    const handleClose = () => {
        setShowMsg(false);
    };

    const handleSave = (announcement,status) => {
        const save = async () => {
            let body = {
                'id':                  announcement.id,
                'title':               announcement.title,
                'announcementContent': announcement.announcementContent,
                'announcementType':    'ReleaseNote',
                // 'status':              status,
                'version':             announcement.version,
                'startDate':           new Date().toISOString()
                // 'endDate':             announcement.endDate,

            };
            let response =await updateAnnouncement(body,announcement.id);
            getAnnouncementList(response);
        };

        save();  
    };

    const fetchUserData = (requestData, actionType) => {
        switch (actionType) {
            case 'select':
                handleAnnouncementClick(requestData);
                break;
            case 'delete':
                handleAnnouncementDelete(requestData);
                break;
            case 'active':
                handleAnnouncementPublish(requestData,'Active');
                break;
            case 'inactive':
                handleAnnouncementPublish(requestData,'Inactive');
                break;
            case 'clone':
                handleAnnouncementClone(requestData,'clone');
                break;
            default:
                break;
        }
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type="Announcements"
                    entityData={props.dataItem}
                    onFetch={(requestData, actionType) => fetchUserData(requestData, actionType)}
                />
            </td>
        );
    };

    const handleAnnouncementClick = (announcement) => {
        if (currentUser.isSuperUser) {
            setSelectedAnnouncement(announcement);
        }
        else {
            setCurrentAnnouncement(announcement);
            setShowMsg(true);
        }
    };

    const handleAnnouncementClone = (announcement) => {
        const annCopy = {
            announcementContent: announcement.announcementContent,
            announcementType:    announcement.announcementType,
            announcementTypeLbl: announcement.announcementTypeLbl,
            title:               announcement.title

        };
        setSelectedAnnouncement(annCopy);
    };

    const handleAnnouncementDelete = (announcement) => {
        setCurrentAnnouncement(announcement);
        setDeleteModal(true);
    };

    const handleCloseDeleteModal = (announcement) => {
        setDeleteModal(false);
    };

    const handleDelete = () => {
        const deleteAnnouncementList = async (items) => {
            if (items.length === 0) {
                let response = await deleteAnnouncement(currentAnnouncement.id);
                getAnnouncementList(response);
            }
            else {
                let response = await deleteAnnouncements(items);
                getAnnouncementList(response);
            }
        };

        if (currentAnnouncement && currentAnnouncement.id) {
            deleteAnnouncementList([]);
        }
        else {
            let items = [];
            for (let i=0; i< announcementList.length; i++) {
                if (announcementList[i].checked) {
                    items.push(announcementList[i].id);
                }
            }
            if (items.length>0) {
                deleteAnnouncementList(items);
            }
        }
    };

    const handleAnnouncementPublish = (announcement,status) => {
        handleSave(announcement,status);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <div>
                    <span
                        className={classes.NameField}
                        aria-hidden="true"
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                            handleAnnouncementClick(
                                props.dataItem
                            )
                        }
                    >
                        {props.dataItem.title}
                    </span>
                </div>
            </td>
        );
    };
   
    const dateCell = props => {
        const zone = moment.tz.guess();
        const parsedDate = Date.parse(props.dataItem[props.field]);
        const displayDate = isNaN(parsedDate) === false && new Date(props.dataItem[props.field]) < new Date(2099, 11, 31) ? new moment(props.dataItem[props.field]).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(parsedDate, zone) : '';

        return (
            <td>{displayDate}</td>
        );
    };

    const statusCell = props => {
        return (
            <td>
                {props.dataItem[props.field].toLowerCase() === 'active' ? <span  className={'material-icons green-status'}>done_outline</span> : null}
                {props.dataItem[props.field].toLowerCase() === 'active' ? ' ' : null}
                <span>{props.dataItem[props.field]}</span>
            </td>
        );
    };

    const refreshGrid = () => {
        const refresh = async () => {
            let admin = currentUser.isSuperUser;
            await fetchAnnouncementsList(admin);

            let filteredData = [];
            if (searchTerm) {
                announcements.every(item => {
                    let keys = Object.keys(item);
                    keys.every(c => {
                        if (item[c] && item[c].toString().toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
                            filteredData.push(item);
                            return false;
                        }
                        return true;
                    });
                    return true;
                });
                setAnnouncementList(filteredData);
            }
            else setAnnouncementList(announcements);
        };
        refresh();
    };

    const onColumnReorder = e => {
        const titleColumn = e.columns.find(c => c.id === 'titleColumn');
        if (titleColumn) {
            setTitleColumnIndex(titleColumn.orderIndex + 1);
        }
    };

    const onDataStateChange = e => {
        setGridDataState(e.dataState);
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div className={`announcement-table ${classes.Table}`}>
            <div className={classes.TableContainerHead}>
                <div className={classes.WorkbookModeContainer}>
                    <BobWorkbookModeButton
                        handleWorkbookMode={handleWorkbookMode}
                        workbookMode={workbookModeEnabled}
                    />
                </div>
                <div className={classes.TotalsContainer}>
                    <TotalsPanel
                        data={{ totalRecordCount: announcementList ? announcementList.length : 0 }}
                        entityType={'Announcements'}
                    />
                </div>
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                {currentUser.isSuperUser ?
                    <div className={classes.ActionButtonContainer}>
                        <BobActionMenu
                            type="Announcements"
                            deleteFl = {false}
                            handleCreateAnnouncements={() => setAnnouncementCreate(!announcementCreate)}
                            setAsActive={() => handleClickAction('active')}
                            setAsInActive={() => handleClickAction('inactive')}
                            handleDelete={() => handleClickAction('delete')}
                        />
                    </div>
                    :''}
            </div>
            <React.Fragment>
                <style>
                    { kendoGridInlineStyling }
                    {
                        `
                        .k-grid-header col:nth-of-type(${titleColumnIndex}) {
                            min-width: 250px
                        }
                        .k-grid-table col:nth-of-type(${titleColumnIndex}) {
                            min-width: 250px
                        }
                        `
                    }
                </style>
                <Grid
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={aclasses.KendoGrid}
                    data={kendoProcess(announcementList ? announcementList : [], gridDataState)}
                    {...gridDataState}
                    filterable={workbookModeEnabled}
                    pageable={pageable}
                    reorderable
                    onDataStateChange={onDataStateChange}
                    onColumnReorder={onColumnReorder}
                >
                    <Column
                        title="Title"
                        field="title"
                        cell={nameCell}
                        id="titleColumn"
                    />
                    <Column
                        title="Type"
                        field="announcementTypeLbl"
                        width="150px"
                    />
                    <Column
                        title="Version"
                        width="150px"
                        field="version"
                    />
                    <Column
                        title="Created By"
                        width="175px"
                        field="createdBy"
                    />
                    <Column 
                        title="Created Date"
                        width="180px"
                        field="insertTimestamp"
                        cell={dateCell}
                        filter={'date'}
                    />
                    <Column
                        title="Edited By"
                        width="180px"
                        field="updatedBy"
                    />
                    <Column 
                        title="Edited On"
                        width="180px"
                        field="lastModifiedTimestamp"
                        cell={dateCell}
                        filter={'date'}
                    />
                    <Column 
                        title="Start Date"
                        width="180px"
                        field="startDate"
                        cell={dateCell}
                        filter={'date'}
                    />
                    <Column 
                        title="End Date"
                        width="180px"
                        field="endDate"
                        cell={dateCell}
                        filter={'date'}
                    />
                    <Column
                        title="Status"
                        width="125px"
                        field="status"
                        cell={statusCell}
                    />
                    <Column
                        field=""
                        title=""
                        width="80px"
                        locked={true}
                        sortable={false}
                        filterable={false}
                        cell={actionsCell}
                    />
                </Grid>
                {deleteModal ?
                    <DeleteAnnouncementModal
                        open={deleteModal}
                        close={(announcement) => handleCloseDeleteModal(announcement)}
                        handleDelete={handleDelete}
                        currentAnnouncement={currentAnnouncement}
                        message={`${currentAnnouncement ? `Are you sure you want to delete ${currentAnnouncement.title}?` : `Are you sure you want to delete the selected announcements?`}`}
                        title={`Confirm Delete: ${currentAnnouncement ? currentAnnouncement.title : 'Announcements'}`}
                    />
                    : ''}
                {
                    bobLoading.includes('Announcements') ?
                        <BobLoadingMask
                            className={classes.Loader}
                        />
                        :
                        null
                }
                { showMsg?
                    <AnnouncementModal
                        title={currentAnnouncement.title}
                        selectedAnnouncement={currentAnnouncement}
                        open={showMsg}
                        close={handleClose}
                    />:''
                }
            </React.Fragment>
        </div>
    );
};

AnnouncementsList.defaultProps = {
    announcementList: [],
    currentUser:      {}
};

AnnouncementsList.propTypes = {
    announcementList: array,
    currentUser:      object
};

const mapStateToProps = state => ({
    activeNavCompany:    state.bob.activeNavCompany,
    bobLoading:          state.bob.bobLoading,
    announcements:       state.dashboard.announcements,
    currentUser:         state.currentUser,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnnouncementsList));
